import { registerPlugin } from "@capacitor/core";
export const CollabLLM = registerPlugin("CollabLLM", {
    web: () => import("./web.js").then((m) => new m.CollabLLMWeb()),
});
export * from "./definitions.js";
//# sourceMappingURL=index.js.map